export const phoneRegex = /^(\+\d{1,4})?\s*\d{10,}$/;
export const emailRegex =
/^([a-zA-Z0-9_\-]+(?:\.[a-zA-Z0-9_\-]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,15}|[0-9]{1,3})(\]?[\s]*)$/;
export const pinRegex = /^[0-9]{5,10}$/;
export const addressRegex = /^[a-zA-Z0-9, -.:/\n]{1,250}$/;
export const nameRegex = /^(?!\s)[\w\s'"\-.,;()&$#@!%^*\[\]{}+=<>/\\?_]{3,}$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;<>,.?~\\/-]).{8,100}$/;
export const sixDigitOTPRegex = /^\d{6}$/;

export const calculatePasswordStrength = (password: string): number => {

    const minLength = 8;
    const extendedSymbolRegex = /[!@#$%^&*()_+={}\[\]:;<>,.?~\\/-]/;

    let strengthCount = 0;
    // Length check
    if (password.length >= minLength) strengthCount++;
    // Lowercase and Uppercase letters check
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strengthCount++;
    // Digits check
    if (/\d/.test(password)) strengthCount++;
    // Symbols check
    if (extendedSymbolRegex.test(password)) strengthCount++;

    return strengthCount;
};